import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationServices } from '../../../appauth/notification/notificatio.services';
import { CustomValidators } from 'ng2-validation';
import { EvidenciasServices } from '../evidencia/evidencias.services';

@Component({
	selector: 'app-add-foto-pagogasto',
	templateUrl: './evidencia.compente.html',
	styleUrls: ['./evidencia.compente.scss']
})

export class EvidenciasComponent implements OnInit {
    
    @Input() Pagogasto:any;
    
	constructor(private fb: FormBuilder,
		private activeModal:NgbActiveModal,
		private servicioEvidencias:EvidenciasServices,
		private Noti:NotificationServices,) { }

	ngOnInit() {
		console.log(this.Pagogasto);
        
	}


	onFileChange(event) {
    if(event.target.files.length > 0) {
        var file = event.target.files[0];
        var formData = new FormData();
        
        formData.append('filename', file);
        formData.append('pagogasto_id',this.Pagogasto.id);
        this.servicioEvidencias.saveEvidencia(formData).subscribe((data:any)=>{
        if(data.estado){
            this.Noti.setNotification(data).then((datas)=>{
            if(datas){
                this.activeModal.close(1);
            }
            }); 
            
        }else{
            this.Noti.setNotification(data);
        }
        });
    }
    }

}